import { subscribe } from './event-logger';
import { META_EVENT_TYPES } from './event-types';

const DEFAULT_META_PIXEL_ID = '27664480569874607';
const MEMORY_KEEPER_META_PIXEL_ID = '28641362678795139';

// Funnels not listed here fall back to DEFAULT_META_PIXEL_ID.
const META_PIXEL_ID_BY_VERSION = {
    v46: MEMORY_KEEPER_META_PIXEL_ID,
    v47: MEMORY_KEEPER_META_PIXEL_ID,
    v48: MEMORY_KEEPER_META_PIXEL_ID
};

const getMetaPixelId = version => {
    const baseVersion = version?.split('.')[0];

    return META_PIXEL_ID_BY_VERSION[baseVersion] || DEFAULT_META_PIXEL_ID;
};

let isInitialized = false;

function initMetaPixel(version) {
    if (isInitialized || window.fbq) {
        return;
    }

    isInitialized = true;

    /* eslint-disable */
    !function(f,b,e,v,n,t,s)
    {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
    n.callMethod.apply(n,arguments):n.queue.push(arguments)};
    if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
    n.queue=[];t=b.createElement(e);t.async=!0;
    t.src=v;s=b.getElementsByTagName(e)[0];
    s.parentNode.insertBefore(t,s)}(window,document,'script',
    'https://connect.facebook.net/en_US/fbevents.js');
    /* eslint-enable */

    window.fbq('init', getMetaPixelId(version));
    window.fbq('track', 'PageView');
}

const metaTracker = {
    track(event) {
        if (!window.fbq) {
            return;
        }

        window.fbq('track', event);
    }
};

subscribe((eventType) => {
    if (META_EVENT_TYPES.hasOwnProperty(eventType)) {
        metaTracker.track(META_EVENT_TYPES[eventType]);
    }
});

export {
    metaTracker,
    initMetaPixel,
    getMetaPixelId
};
